/**
 * Delivery Cookie Manager
 * Handles cookie-based storage for delivery data with 20-minute timeout
 */

window.DeliveryCookieManager = window.DeliveryCookieManager || {
  COOKIE_NAME: 'delivery_data',
  EXPIRY_MINUTES: 20,
  CART_INACTIVITY_MINUTES: 10,
  cartInactivityTimer: null,
  
  /**
   * Set a cookie with the delivery data
   */
  setCookie: function(data) {
    const expiryDate = new Date();
    expiryDate.setMinutes(expiryDate.getMinutes() + this.EXPIRY_MINUTES);
    
    const cookieData = {
      data: data,
      cookieTimestamp: Date.now(), // Internal cookie timestamp (different from delivery timestamp)
      expiry: expiryDate.getTime()
    };
    
    const cookieValue = encodeURIComponent(JSON.stringify(cookieData));
    const cookieString = `${this.COOKIE_NAME}=${cookieValue}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
    
    document.cookie = cookieString;
    console.log('TEST:: Delivery cookie set with 20-minute expiry, delivery timestamp:', data.timestamp);
  },
  
  /**
   * Get the delivery data from cookie if valid
   */
  getCookie: function() {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === this.COOKIE_NAME) {
        try {
          const cookieData = JSON.parse(decodeURIComponent(value));
          
          // Check if cookie has expired
          if (cookieData.expiry && Date.now() > cookieData.expiry) {
            console.log('TEST:: Delivery cookie has expired');
            this.deleteCookie();
            return null;
          }
          
          return cookieData.data;
        } catch (e) {
          console.error('TEST:: Error parsing delivery cookie:', e);
          return null;
        }
      }
    }
    return null;
  },
  
  /**
   * Delete the delivery cookie
   */
  deleteCookie: function() {
    document.cookie = `${this.COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log('TEST:: Delivery cookie deleted');
  },
  
  /**
   * Check if delivery data has expired and handle accordingly
   */
  checkExpiry: async function() {
    const data = this.getCookie();
    if (!data) {
      // Cookie expired or doesn't exist
      console.log('TEST:: Delivery data expired or missing, clearing cart attributes');
      
      // Clear cart attributes via API
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Delivery postcode': '',
              'Delivery suburb': '',
              'Delivery date': '',
              'Delivery time': '',
              'Delivery details entered at': ''
            }
          })
        });
        
        if (response.ok) {
          console.log('TEST:: Cart attributes cleared successfully');
        }
      } catch (error) {
        console.error('TEST:: Error clearing cart attributes:', error);
      }
      
      // Show expiry message
      this.showExpiryMessage();
      
      return false;
    }
    return true;
  },
  
  /**
   * Show expiry message to user
   */
  showExpiryMessage: function() {
    // Check if we're on the cart page
    const cartForm = document.querySelector('.cart-delivery-form');
    if (cartForm) {
      // Clear all delivery form fields
      const postcodeInput = document.querySelector('.cart-delivery-input-postcode');
      const suburbSelect = document.querySelector('.cart-delivery-input-suburb');
      const datepicker = document.querySelector('.cart-delivery-datepicker');
      const timeSelector = document.querySelector('.cart-delivery-time-selector');
      
      if (postcodeInput) postcodeInput.value = '';
      if (suburbSelect) {
        suburbSelect.innerHTML = '<option value="">Select Suburb</option>';
        suburbSelect.disabled = true;
      }
      if (datepicker) datepicker.value = '';
      if (timeSelector) {
        timeSelector.innerHTML = '';
        timeSelector.disabled = true;
      }
      
      // Show expiry notification
      const existingNotice = document.querySelector('.delivery-expiry-notice');
      if (!existingNotice) {
        const notice = document.createElement('div');
        notice.className = 'delivery-expiry-notice';
        notice.style.cssText = `
          background-color: #fff3cd;
          border: 1px solid #ffc107;
          color: #856404;
          padding: 12px 15px;
          border-radius: 8px;
          margin-bottom: 15px;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 10px;
        `;
        notice.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15h-2v-2h2v2zm0-4h-2V5h2v6z"/>
          </svg>
          <span>Your delivery details have expired. Please re-enter your delivery information.</span>
        `;
        
        const formMain = document.querySelector('.cart-delivery-form-main');
        if (formMain) {
          formMain.insertBefore(notice, formMain.firstChild);
          
          // Auto-remove notice after 10 seconds
          setTimeout(() => {
            notice.style.transition = 'opacity 0.5s';
            notice.style.opacity = '0';
            setTimeout(() => notice.remove(), 500);
          }, 10000);
        }
      }
    }
    
    // Also check if we're in the inline datepicker section
    const inlineDatepicker = document.querySelector('.datepicker-input');
    if (inlineDatepicker) {
      inlineDatepicker.value = '';
      const inlineTimeSelector = document.querySelector('.time-selector');
      if (inlineTimeSelector) {
        inlineTimeSelector.innerHTML = '';
        inlineTimeSelector.disabled = true;
      }
      
      // Show inline expiry notice
      const existingInlineNotice = document.querySelector('.inline-delivery-expiry-notice');
      if (!existingInlineNotice) {
        const notice = document.createElement('div');
        notice.className = 'inline-delivery-expiry-notice';
        notice.style.cssText = `
          background-color: #fff3cd;
          border: 1px solid #ffc107;
          color: #856404;
          padding: 10px;
          border-radius: 5px;
          margin-top: 10px;
          font-size: 13px;
        `;
        notice.textContent = 'Delivery details expired. Please select again.';
        
        const datePickerBlock = document.querySelector('.date-picker-block');
        if (datePickerBlock) {
          datePickerBlock.appendChild(notice);
          
          setTimeout(() => {
            notice.style.transition = 'opacity 0.5s';
            notice.style.opacity = '0';
            setTimeout(() => notice.remove(), 500);
          }, 10000);
        }
      }
    }
  },
  
  /**
   * Refresh cookie expiry time (call this on user activity)
   */
  refreshExpiry: function() {
    const data = this.getCookie();
    if (data) {
      this.setCookie(data);
      console.log('TEST:: Delivery cookie expiry refreshed');
    }
  },
  
  /**
   * Start the cart inactivity timer (10 minutes)
   */
  startCartInactivityTimer: function() {
    // Clear any existing timer
    if (this.cartInactivityTimer) {
      clearTimeout(this.cartInactivityTimer);
    }
    
    console.log(`TEST:: Starting cart inactivity timer (${this.CART_INACTIVITY_MINUTES} minutes)`);
    
    this.cartInactivityTimer = setTimeout(() => {
      console.log('TEST:: Cart inactivity timeout reached - clearing delivery data and reloading');
      
      // Delete the delivery cookie
      this.deleteCookie();
      
      // Clear cart attributes
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'Delivery postcode': '',
            'Delivery suburb': '',
            'Delivery date': '',
            'Delivery time': '',
            'Delivery details entered at': ''
          }
        })
      }).then(() => {
        // Reload the page to show fresh cart without stale delivery data
        window.location.reload();
      }).catch(error => {
        console.error('TEST:: Error clearing cart attributes during inactivity timeout:', error);
        // Still reload even if API call fails
        window.location.reload();
      });
      
    }, this.CART_INACTIVITY_MINUTES * 60 * 1000);
  },
  
  /**
   * Reset the cart inactivity timer (call on user activity)
   */
  resetCartInactivityTimer: function() {
    if (this.cartInactivityTimer) {
      console.log('TEST:: Resetting cart inactivity timer due to user activity');
      this.startCartInactivityTimer();
    }
  }
};

// Check expiry on page load
window.addEventListener('DOMContentLoaded', function() {
  window.DeliveryCookieManager.checkExpiry();
  
  // Check if we're on the cart page and start inactivity timer
  const isCartPage = document.querySelector('.cart-delivery-form') || document.querySelector('#cart_form');
  if (isCartPage) {
    console.log('TEST:: Cart page detected - starting inactivity timer');
    window.DeliveryCookieManager.startCartInactivityTimer();
  }
  
  // Check expiry every minute
  setInterval(function() {
    window.DeliveryCookieManager.checkExpiry();
  }, 60000);
  
  // Refresh expiry on user activity in delivery forms
  document.addEventListener('change', function(e) {
    if (e.target.matches('.cart-delivery-input, .cart-delivery-datepicker, .cart-delivery-time-selector, .datepicker-input, .time-selector')) {
      DeliveryCookieManager.refreshExpiry();
      // Also reset cart inactivity timer on delivery form interactions
      DeliveryCookieManager.resetCartInactivityTimer();
    }
  });
  
  // Also listen for input and focus events for more responsive timer resets
  document.addEventListener('input', function(e) {
    if (e.target.matches('.cart-delivery-input, .cart-delivery-datepicker, .cart-delivery-time-selector, .datepicker-input, .time-selector')) {
      DeliveryCookieManager.resetCartInactivityTimer();
    }
  });
  
  document.addEventListener('focus', function(e) {
    if (e.target.matches('.cart-delivery-input, .cart-delivery-datepicker, .cart-delivery-time-selector, .datepicker-input, .time-selector')) {
      DeliveryCookieManager.resetCartInactivityTimer();
    }
  });
});

// DeliveryCookieManager is now available globally via window.DeliveryCookieManager